import React from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import { Card } from 'material-ui/Card';
import palette from '../theme/palette';

const style = {
  card: {
    width: '100%',
    margin: '24px auto',
    padding: '0px 32px 32px 32px',
    borderRadius: 12,
    boxShadow: '0 1px 3px rgba(30, 36, 51, 0.04), 0 6px 16px rgba(30, 36, 51, 0.06)',
    border: '1px solid rgba(30, 36, 51, 0.06)',
    backgroundColor: 'var(--sl-bg-surface)',
  },
  cardWithoutTitle: {
    paddingTop: 32,
  },
  cardTitle: {
    color: palette.grey600,
    borderBottom: `1px solid ${palette.grey200}`,
    margin: '0px -32px',
    padding: '24px 32px 20px 32px',
    marginBottom: 24,
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: '-0.01em',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardSubtitle: {
    fontSize: 13,
    paddingTop: 6,
    color: palette.grey400,
    fontWeight: 400,
  },
};

const CustomCard = (props) => (
  <Card
    style={
      props.title ? style.card : merge({}, style.card, style.cardWithoutTitle)
    }
    className="card"
  >
    {props.title && (
      <div style={style.cardTitle}>
        <div>
          {props.title}
          {props.subtitle && (
            <div style={style.cardSubtitle}>{props.subtitle}</div>
          )}
        </div>
        {props.headerRight}
      </div>
    )}
    {props.content}
  </Card>
);

CustomCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.node,
  headerRight: PropTypes.node,
};

export default CustomCard;
